export default __webpack_public_path__ + "static/media/icon-highlight-technology.600fa6ca.svg";